import styled from '@emotion/styled';
import { Theme } from '@silvertours/front-shared';
import { IconColor, IconSize, IconSizes } from './rule';

const getSizes = (
  size: IconSize | IconSizes,
  theme: Theme.Theme,
  mq?: 'sm' | 'md' | 'lg' | 'xl',
) => {
  if (Array.isArray(size)) {
    const responsiveSizeForMedia = size.find(
      ([, _breakpoint]) => _breakpoint === mq,
    );
    if (responsiveSizeForMedia) {
      const [responsiveSize] = responsiveSizeForMedia;
      return responsiveSize === 'full' ? '100%' : theme.spacing[responsiveSize];
    }
    return null;
  }

  return size === 'full' ? '100%' : theme.spacing[size];
};

const IconWrapper = styled.div<{
  color: IconColor;
  indent: Theme.SpacingKeys;
  size: IconSize | IconSizes;
}>`
  & > svg {
    border-radius: 0;
    padding: ${({ indent, theme }) => `0 ${theme.spacing[indent]}`};
    fill: ${({ color, theme }) =>
      color === 'current' ? 'current' : theme.color[color]};
    width: ${({ size, theme }) => getSizes(size, theme)};
    height: ${({ size, theme }) => getSizes(size, theme)};

    ${Theme.mq('sm')} {
      width: ${({ size, theme }) => getSizes(size, theme, 'sm')};
      height: ${({ size, theme }) => getSizes(size, theme, 'sm')};
    }
    ${Theme.mq('md')} {
      width: ${({ size, theme }) => getSizes(size, theme, 'md')};
      height: ${({ size, theme }) => getSizes(size, theme, 'md')};
    }
    ${Theme.mq('lg')} {
      width: ${({ size, theme }) => getSizes(size, theme, 'lg')};
      height: ${({ size, theme }) => getSizes(size, theme, 'lg')};
    }
    ${Theme.mq('xl')} {
      width: ${({ size, theme }) => getSizes(size, theme, 'xl')};
      height: ${({ size, theme }) => getSizes(size, theme, 'xl')};
    }
  }
`;

export { IconWrapper };
